import GatewayBase from './gateway-base';

export interface IntegrationFieldDefinition {
  [key: string]: {
    type: string;
    display: string;
    attributes: Record<string, any>;
  };
}

export default class SubscriptionsService extends GatewayBase {
  get integrations() {
    return {
      installed: this.getInstalledIntegrations,
      list: this.listIntegrations,
      setEnabled: this.setIntegrationEnabled,
      update: this.updateIntegrationConfiguration,
    };
  }

  private listIntegrations = () => {
    return this.client.get<{
      schemas: { id: string; name: string; icon: string; fields: IntegrationFieldDefinition }[];
    }>('/v1/subscriptions/integrations');
  };

  private getInstalledIntegrations = (storeId: string) => {
    return this.client.get<{ integrationId: string; storeId: string; enabled: boolean; configuration: any }[]>(
      `/v1/subscriptions/integrations/installed/${storeId}`,
    );
  };

  private updateIntegrationConfiguration = (id: string, storeId: string, data: any) => {
    return this.client.put(`/v1/subscriptions/integrations/${id}/${storeId}`, data);
  };

  private setIntegrationEnabled = (id: string, storeId: string, enabled: boolean) => {
    return this.client.patch(`/v1/subscriptions/integrations/${id}/${storeId}/enabled`, { enabled });
  };
}
